export const SANDBOX_EGRESS_REFUSED_CODE = "SANDBOX_EGRESS_REFUSED"

export const SANDBOX_STORE_UNSUPPORTED_CODE = "SANDBOX_STORE_UNSUPPORTED"

export const SANDBOX_SESSION_INVALID_CODE = "SANDBOX_SESSION_INVALID"

export const SANDBOX_SESSION_CAP_EXCEEDED_CODE = "SANDBOX_SESSION_CAP_EXCEEDED"

export const SANDBOX_NOT_CONFIGURED_CODE = "SANDBOX_NOT_CONFIGURED"
